import { IPerformanceTimingData } from 'common/utilities/PerformanceService.types';

export function getInitialPerformanceState(): IPerformanceTimingData {
  return {
    pageLoadTime: 0,
    navigationStartTime: 0,
    isPageLoadComplete: false,
  };
}
